import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Link from "@material-ui/core/Link";
import { IS_DESKTOP } from "../util";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles(({ palette, spacing, breakpoints }) => ({
  root: {
    backgroundColor: palette.primary.main,
    minHeight: "61.8vh",
    color: palette.primary.contrastText,
    padding: (props) =>
      props.isMobile ? spacing(2, 0, 7, 0) : spacing(2, 0, 12, 0),
  },
  description: {
    maxWidth: 600,
  },
  avatar: {
    "& img": {
      width: "auto",
    },
    width: spacing(13),
    height: spacing(13),
  },
}));

function Intro() {
  const { root, description, avatar } = useStyles({ isMobile: !IS_DESKTOP() });

  return (
    <Grid
      className={root}
      container
      direction={"column"}
      alignItems={"center"}
      justify={"space-between"}
      component={"section"}
    >
      <Avatar
        src={"https://ufal.br/++theme++ufal.tema.tematico/imgs/brasao.png"}
        variant={"square"}
        className={avatar}
        alt={"Logos da UFAL"}
        component={Link}
        href={"https://ufal.br"}
        target={"_blank"}
        rel={"nofollow noreferrer noopener"}
      />
      <Box color={"primary.light"} clone>
        <Typography
          variant={IS_DESKTOP() ? "h3" : "h5"}
          component={"h1"}
          gutterBottom
          align={"center"}
        >
          Unidade Acadêmica ESENFAR
        </Typography>
      </Box>
      <Typography
        variant={"body1"}
        gutterBottom
        className={description}
        align={"center"}
      >
        A ESENFAR foi segmentada nas seguintes unidades:
        <br />
        <b>Escola de Enfermagem</b> e <b>Instituto de Ciências Farmacêuticas</b>{" "}
        de acordo com peculiaridades de cada área.
      </Typography>
    </Grid>
  );
}

export default Intro;
